module.exports = __webpack_public_path__ + "static/media/drivelah-security.f13f7c66.svg";